var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPg = function SvgPg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.485 20.486c-4.686 4.686-12.284 4.686-16.97 0-4.687-4.687-4.687-12.285 0-16.97C8.2-1.172 15.06-.435 19.747 4.252c4.687 4.686 5.425 11.546.738 16.233Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M3.515 3.515c4.686-4.687 12.284-4.687 16.97 0 4.687 4.686 4.687 12.284 0 16.97"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m9.172 16.174.194.598h.628l-.508.37.194.597-.508-.37-.51.37.195-.598-.508-.37h.628l.195-.597ZM7.565 10.435l.324.996h1.047l-.847.616.323.997-.847-.616-.848.616.324-.997-.848-.616h1.048l.324-.996ZM7.565 17.739l.324.996h1.047l-.847.616.323.997-.847-.616-.848.616.324-.997-.848-.616h1.048l.324-.996ZM10.63 13.044l.323.996h1.048l-.848.616.324.997-.848-.616-.847.616.323-.997-.847-.616h1.048l.323-.996ZM4.502 13.044l.324.996h1.048l-.848.616.324.997-.848-.616-.847.616.324-.997-.848-.616h1.048l.323-.996Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M20.088 8.886a3.107 3.107 0 0 0-1.982-.907l2.241-1.744a4.164 4.164 0 0 0-3.256-1.21 3.115 3.115 0 0 0-.802-1.372l-.885 1.77a1.304 1.304 0 1 0-1.77 1.77l-1.772.887c.395.395.87.662 1.373.802a4.162 4.162 0 0 0 1.21 3.256l1.958-2.518a.778.778 0 0 1 .55-.225c.208 0 .405.081.553.23.147.147.229.344.229.553a.778.778 0 0 1-.23.553l.738.738c.345-.345.535-.803.535-1.291 0-.4-.127-.779-.362-1.092.342.091.666.27.934.538a2.09 2.09 0 0 1 0 2.952l.738.738a3.11 3.11 0 0 0 .917-2.214 3.11 3.11 0 0 0-.917-2.214Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPg;